// extracted by mini-css-extract-plugin
module.exports = {"main-context":"Setting_main-context__2_vyu"};